/* tslint:disable:prefer-for-of */
import * as React from 'react'

interface IProps {
  data: any
  progress: number
  colour: string
  viewType: string
}

interface IState {
  waveformData: any
}

export default class Waveform extends React.Component<IProps, IState> {
  private canvasElement: HTMLCanvasElement
  private canvasContainerElement: HTMLDivElement

  constructor(props: IProps) {
    super(props)
    this.state = {
      waveformData: this.sampleData(props.data)
    }

    this.handleWindowResize = this.handleWindowResize.bind(this)
    this.setCanvasContainerRef = this.setCanvasContainerRef.bind(this)
    this.setCanvasRef = this.setCanvasRef.bind(this)
  }

  public componentWillReceiveProps(nextProps: IProps) {
    // This is a horrible hack to force the data to resize
    // when switching between grid & list view only
    // after the component has rendered
    this.setState({}, () => this.handleWindowResize())
  }

  public componentDidMount() {
    this.updateWaveform()
    window.addEventListener('resize', this.handleWindowResize, true)
  }

  public componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize, true)
  }

  public render() {
    const { progress } = this.props

    return (
      <div
        ref={this.setCanvasContainerRef}
        style={{
          width: `${progress * 100}%`,
          height: '100%',
          position: 'absolute',
          overflow: 'hidden'
        }}
      >
        <canvas
          ref={this.setCanvasRef}
          style={{
            height: '100%',
            position: 'absolute'
          }}
        />
      </div>
    )
  }

  private handleWindowResize() {
    if (this.canvasElement) {
      const parent = this.canvasContainerElement.parentNode as HTMLElement
      this.canvasElement.style.width = `${parent.clientWidth}px`
    }
  }

  private sampleData(response: { length: number; data: number[] }) {
    const form: { max: number; samples: number[] } = { max: 1, samples: [] }
    for (let i = 0; i < response.length; i++) {
      const sample = response.data[i * 2 + 1] - response.data[i * 2]
      form.samples.push(sample)
      if (sample > form.max) {
        form.max = sample
      }
    }
    return form
  }

  private updateWaveform() {
    const { colour } = this.props
    const { waveformData } = this.state
    const canvasContainer = this.canvasContainerElement
    const canvas = this.canvasElement

    const context = canvas.getContext('2d') as CanvasRenderingContext2D
    const parent = canvasContainer.parentNode as HTMLElement
    canvas.style.width = `${parent.clientWidth}px`
    canvas.width = this.state.waveformData.samples.length

    // Clear the canvas
    context.clearRect(0, 0, canvas.width, canvas.height)

    // Pre-calculate some values
    const yBaseline = canvas.height / 2
    const yMultiplier = yBaseline / waveformData.max

    // Draw the dividing middle line
    context.lineWidth = 0.1
    context.beginPath()
    context.moveTo(0, yBaseline)
    context.lineTo(canvas.width, yBaseline)
    context.stroke()

    // Draw the top part of the waveform
    context.fillStyle = colour
    context.beginPath()
    context.moveTo(0, yBaseline)
    for (let i = 0; i < waveformData.samples.length; i++) {
      context.lineTo(i, yBaseline - waveformData.samples[i] * yMultiplier)
    }
    context.lineTo(canvas.width, yBaseline)
    context.closePath()
    context.fill()

    // Draw the bottom part
    context.beginPath()
    context.moveTo(0, yBaseline)
    for (let i = 0; i < waveformData.samples.length; i++) {
      context.lineTo(i, yBaseline + waveformData.samples[i] * yMultiplier)
    }
    context.lineTo(canvas.width, yBaseline)
    context.closePath()
    context.fill()
  }

  private setCanvasContainerRef(canvasContainerElement: HTMLDivElement) {
    this.canvasContainerElement = canvasContainerElement
  }

  private setCanvasRef(canvasElement: HTMLCanvasElement) {
    this.canvasElement = canvasElement
  }
}
